export default {
  profile: 'プロフィール',
  settings: '設定',
};
